document.addEventListener('DOMContentLoaded', () => {
    let buttonReadMore = document.querySelector('.js-multi-column__item-button');
    let info = document.querySelector('.js-multi-column__info-wrapper')
    let description = document.querySelector('.js-multi-column__item-description');
    if(buttonReadMore && info){
        buttonReadMore.addEventListener("click", function (e) {
            info.classList.add('multi-column__info-wrapper--show');
            buttonReadMore.classList.add('multi-column__item-button--hide');
            description.classList.add('multi-column__item-description--hide');
        });
    }

    let buttonReadMoreDesc = document.querySelector('.js-multi-column__item-button--description');


    let heightDesc = description.offsetHeight;

    if(heightDesc < 260) {
        buttonReadMoreDesc.classList.add('multi-column__item-button--hide');
        description.classList.add('multi-column__item-description--hide');
    }


    if(buttonReadMoreDesc && description){
        buttonReadMoreDesc.addEventListener("click", function (e) {
            description.classList.add('multi-column__info-wrapper--show');
            buttonReadMoreDesc.classList.add('multi-column__item-button--hide');
        });
    }

});